import { SkillEnum } from '@/types'

type SkillStep = {
  required?: boolean
  next: SkillEnum[]
}

type SkillOrderMap = {
  [key in SkillEnum]?: SkillStep
}

// Define the possible starting points and their progressions
export const SKILL_ORDER: {
  start: SkillEnum[]
  progression: SkillOrderMap
} = {
  // Initial skills that can start a wave ride
  start: ['whitewater_riding', 'green_wave_riding'],

  // Progression map defining what skills can follow each skill
  progression: {
    // Riding types (Step 1)
    whitewater_riding: {
      next: ['fitness']
    },
    green_wave_riding: {
      next: ['forecasting_and_observing', 'wave_reading']
    },

    // Knowledge skills (Step 2 - only for green wave riding)
    forecasting_and_observing: {
      next: ['wave_reading']
    },
    wave_reading: {
      next: ['fitness', 'paddling']
    },

    // Base skills (Step 3)
    fitness: {
      required: true,
      next: ['paddling', 'popup']
    },
    paddling: {
      required: true,
      next: ['popup']
    },
    popup: {
      required: true,
      next: ['bottom_turn_front', 'bottom_turn_back', 'speed_generation']
    },

    // Initial maneuvers (Step 4)
    bottom_turn_front: {
      next: [
        'cutback_front',
        'top_turn_front',
        'floater',
        'aerial',
        'air_reverse',
        'barrel',
        'speed_control',
        'speed_generation'
      ]
    },
    bottom_turn_back: {
      next: [
        'cutback_back',
        'top_turn_back',
        'floater',
        'aerial',
        'air_reverse',
        'barrel',
        'speed_control',
        'speed_generation'
      ]
    },
    speed_generation: {
      next: ['speed_control', 'barrel', 'aerial', 'air_reverse', 'cutback_front', 'cutback_back']
    },

    // Secondary maneuvers (Step 5)
    cutback_front: {
      next: ['bottom_turn_front', 'speed_generation']
    },
    cutback_back: {
      next: ['bottom_turn_back', 'speed_generation']
    },
    top_turn_front: {
      next: ['bottom_turn_front', 'speed_generation']
    },
    top_turn_back: {
      next: ['bottom_turn_back', 'speed_generation']
    },
    floater: {
      next: ['bottom_turn_front', 'bottom_turn_back', 'speed_generation']
    },
    aerial: {
      next: ['bottom_turn_front', 'bottom_turn_back', 'speed_generation']
    },
    air_reverse: {
      next: ['bottom_turn_front', 'bottom_turn_back', 'speed_generation']
    },
    barrel: {
      next: ['bottom_turn_front', 'bottom_turn_back', 'speed_generation']
    },
    speed_control: {
      next: ['bottom_turn_front', 'bottom_turn_back', 'speed_generation', 'barrel']
    }
  }
}
